import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useAppSelector } from '../redux/hooks';
import { PageLoader } from './pages/PageLoader';
import ClosedCaptions from './ui/ClosedCaptions';
import PreviewModeFlag from './ui/KenticoConfigFlag';
import { useErrorNotify } from '../adapters';
export function Runtime(props) {
    // TODO: should toggle to "moment container closed-caption" if state.ui.cc is true
    const divClass = 'moment container';
    const errorNotify = useErrorNotify();
    const [loading, setLoading] = React.useState(true);
    const playbackStatus = useAppSelector((state) => state.ui.playbackStatus);
    return (React.createElement(ErrorBoundary, { onError: errorNotify, fallback: React.createElement("div", null, "Error fetching content, try reloading. If problem persists, please contact Support.") },
        React.createElement("div", { className: "conversation" },
            React.createElement(PreviewModeFlag, null),
            React.createElement("div", { className: divClass },
                React.createElement(PageLoader, { ...props, setLoading: setLoading })),
            React.createElement(ClosedCaptions, null))));
}
//# sourceMappingURL=Runtime.js.map